import React from 'react'
import { motion } from 'framer-motion';

const Achievements = ({achievements}) => {
  return (
    <section className="py-5 achievements-section text-light">
        <div className="container text-center">
          <div className="mb-5">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="fw-bold">Recognition & Success</h2>
              <p className="lead">Our commitment to excellence has earned us recognition from industry leaders and satisfied clients worldwide.</p>
            </motion.div>
          </div>
          <div className="row gx-4 gy-4">
            {achievements.map((ach, idx) => {
              const IconComp = ach.icon;
              return (
                <div key={ach.label} className="col-lg-3 col-md-6">
                  <motion.div
                    initial={{ opacity: 0, scale: 0.5 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6, delay: idx * 0.1 }}
                  >
                    <div className="icon-bg rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center">
                      <IconComp size={32} className="text-light" />
                    </div>
                    <h3 className="display-5 fw-bold text-white">{ach.number}</h3>
                    <p className="text-light small">{ach.label}</p>
                  </motion.div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
  )
}

export default Achievements